var _rect, _rect2, _path, _rect3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTotalProducts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 6,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8.60156,
    y: 9.75781,
    width: 20.795,
    height: 4.62111,
    rx: 1,
    fill: "url(#paint0_linear_6078_47439)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.2422 15.5312C27.7945 15.5312 28.2422 15.979 28.2422 16.5312V26.2393C28.2422 27.3438 27.3468 28.2393 26.2422 28.2393H11.7578C10.6532 28.2393 9.75781 27.3438 9.75781 26.2393V16.5312C9.75781 15.979 10.2055 15.5312 10.7578 15.5312H14.6875C15.7921 15.5312 16.6875 16.4267 16.6875 17.5312V17.999C16.6875 18.5513 17.1352 18.999 17.6875 18.999H20.3086C20.8608 18.9989 21.3086 18.5513 21.3086 17.999V17.5312C21.3086 16.4267 22.204 15.5312 23.3086 15.5312H27.2422Z",
    fill: "url(#paint1_linear_6078_47439)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8359,
    y: 15.5312,
    width: 2.31056,
    height: 2.31056,
    fill: "url(#paint2_linear_6078_47439)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6078_47439",
    x1: 8.60156,
    y1: 12.0684,
    x2: 31.5478,
    y2: 12.0684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6078_47439",
    x1: 9.75781,
    y1: 21.8853,
    x2: 30.1545,
    y2: 21.8853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C461"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6078_47439",
    x1: 17.8359,
    y1: 16.6865,
    x2: 20.3855,
    y2: 16.6865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#28A745"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44C461"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTotalProducts);
export default __webpack_public_path__ + "static/media/Total_Products.c1ca48dfccfd8fdc9a486706a092162a.svg";
export { ForwardRef as ReactComponent };